import {
  OPEN_EB_OVERLAY_MODEL,
  CLOSE_EB_OVERLAY_MODEL,
  EMMA_EB_FLEXI_POPUP,
  UPDATE_EB_FLEXI_LOADING,
  UPDATE_CLICK_FROM_BANNER,
  FETCH_EB_FLEXI_SUCCESS,
  UPDATE_EB_FLEXI_TOKEN,
  EB_FLEXI_SHOW_LOADING_BTN,
  EB_FLEXI_HIDE_LOADING_BTN,
} from '../actions/ebFlexiActions';

const defaultState = {
  isClickFromBaner: false,
  isShowPopupModal: false,
  ebFlexiOverlayShow: false,
  isShowBanner: false,
  isLoading: false,
  policyCard: {},
  access_token: '',
  isShowLoadingBtn: false,
};

export default (state: any = defaultState, action: any) => {
  const nextState = { ...state };
  switch (action.type) {
    case FETCH_EB_FLEXI_SUCCESS:
      nextState.isShowBanner = action.isShowBanner;
      nextState.ebFlexiOverlayShow = action.ebFlexiOverlayShow;
      nextState.policyCard = action.policyCard;
      return nextState;
    case OPEN_EB_OVERLAY_MODEL:
      nextState.ebFlexiOverlayShow = true;
      return nextState;
    case CLOSE_EB_OVERLAY_MODEL:
      nextState.ebFlexiOverlayShow = false;
      return nextState;
    case EMMA_EB_FLEXI_POPUP:
      nextState.isShowPopupModal = action.isShowPopupModal;
      return nextState;
    case UPDATE_EB_FLEXI_LOADING:
      nextState.isLoading = action.isLoading;
      return nextState;
    case UPDATE_CLICK_FROM_BANNER:
      nextState.isClickFromBaner = action.isClickFromBaner;
      return nextState;
    case UPDATE_EB_FLEXI_TOKEN:
      nextState.access_token = action.access_token;
      return nextState;
    case EB_FLEXI_SHOW_LOADING_BTN:
      nextState.isShowLoadingBtn = true;
      return nextState;
    case EB_FLEXI_HIDE_LOADING_BTN:
      nextState.isShowLoadingBtn = false;
      return nextState;
    default:
      return nextState;
  }
};
